'use client'

import s from './WorksComponent.module.scss'
import { useContext, useMemo } from 'react'
import { WebContext } from '@/context/webContext'
import FeaturedProduct from '../../Singles/FeaturedProduct'
import SelectedWorkBlock from '@/components/Common/SelectedWorkBlock'

type SelectedBlock = { title?: string; contentLeft?: any[]; contentRight?: any[] } | null
type Props = { data: any[]; selectedBlock?: SelectedBlock }

export default function WorksComponent({ data, selectedBlock }: Props) {
  const { categoriesSelected } = useContext(WebContext)

  const filteredData = useMemo(() => {
    if (!data) return []

    // VIEW ALL → no hay filtros
    if (!categoriesSelected || categoriesSelected.length === 0) {
      return data
    }

    return data.filter((rel) => {
      // 🔹 opción A: categorías como array de strings
      if (Array.isArray(rel.categories)) {
        return rel.categories.some((cat: any) =>
          categoriesSelected.includes(typeof cat === 'string' ? cat : cat.title)
        )
      }

      return false
    })
  }, [data, categoriesSelected])

  return (
    <>
    <div className={s.productsWork}>
      {filteredData.length > 0 && (
        <ul className={s.listProducts}>
          {filteredData.map((rel: any, i: number) => (
            <li key={i}>
              <FeaturedProduct data={rel} />
            </li>
          ))}
        </ul>
      )}
    </div>
    <SelectedWorkBlock data={selectedBlock} />
    </>
  )
}